const useFieldLabel = ({ translate, resource }) => (field) => {
  return translate(`resources.${resource}.fields.${field}`);
};
export default useFieldLabel;
